import { Updater, notFoundRouteCase, route, router } from 'widgets-for-react'
import { RootState } from '../rootState'
import { Pages, routeUpdaters } from './routesState'
import { Routes } from '../../utils/routes'

const routeWidgets: Routes<RootState, Pages> = {
  mailPlusForm: route(
    routeUpdaters.mailPlusForm.url,
    routeUpdaters.mailPlusForm.jumpTo
  ),

  educationForm: route(
    routeUpdaters.educationForm.url,
    routeUpdaters.educationForm.jumpTo
  ),

  eventForm: route(
    routeUpdaters.eventForm.url,
    routeUpdaters.eventForm.jumpTo
  ),

  courseDateSchedule: route(
    routeUpdaters.courseDateSchedule.url,
    routeUpdaters.courseDateSchedule.jumpTo
  ),

  courseSearch: route(
    routeUpdaters.courseSearch.url,
    routeUpdaters.courseSearch.jumpTo
  ),

  actualitySearch: route(
    routeUpdaters.actualitySearch.url,
    routeUpdaters.actualitySearch.jumpTo
  ),

  knowledgeSearch: route(
    routeUpdaters.knowledgeSearch.url,
    routeUpdaters.knowledgeSearch.jumpTo
  ),

  search: route(routeUpdaters.search.url, routeUpdaters.search.jumpTo),

  opleidingenOverview: route(routeUpdaters.opleidingenOverview.url, routeUpdaters.opleidingenOverview.jumpTo),

  magazinesOverviewPage: route(routeUpdaters.magazinesOverviewPage.url, routeUpdaters.magazinesOverviewPage.jumpTo),

  notFound: route(routeUpdaters.notFound.url, routeUpdaters.notFound.jumpTo),

  home: route(routeUpdaters.home.url, routeUpdaters.home.jumpTo),

  previewPage: route(routeUpdaters.previewPage.url, routeUpdaters.previewPage.jumpTo),

  cmsPage: route(routeUpdaters.cmsPage.url, routeUpdaters.cmsPage.jumpTo),

  empty: route(routeUpdaters.empty.url, routeUpdaters.empty.jumpTo)

  // [Custom content types]: Add route here
}


export const routesArray = [
  routeWidgets.courseDateSchedule,
  routeWidgets.courseSearch,
  routeWidgets.actualitySearch,
  routeWidgets.knowledgeSearch,
  routeWidgets.search,
  routeWidgets.opleidingenOverview,
  routeWidgets.magazinesOverviewPage,
  routeWidgets.home,
  routeWidgets.educationForm,
  routeWidgets.eventForm,
  routeWidgets.mailPlusForm,
  routeWidgets.previewPage,

  //generic pages should be kept in the end of the routes list, because they match every path
  routeWidgets.cmsPage,
  notFoundRouteCase<Updater<RootState>>(
    routeUpdaters.notFound.jumpTo
  )
]

export const routesWidget = () =>
  router<Updater<RootState>>()(routesArray)

export const isDifferentRoute: {
  [pageKey in keyof Pages]: (
    oldState: RootState,
    newState: RootState
  ) => boolean
} = {
  mailPlusForm: (o, n) => o.page.kind !== n.page.kind,
  educationForm: (o, n) => o.page.kind !== n.page.kind,
  eventForm: (o, n) => o.page.kind !== n.page.kind,
  courseDateSchedule: (o, n) => o.page.kind !== n.page.kind,
  knowledgeSearch: (o, n) => o.page.kind !== n.page.kind,
  courseSearch: (o, n) => o.page.kind !== n.page.kind,
  actualitySearch: (o, n) => o.page.kind !== n.page.kind,
  search: (o, n) => o.page.kind !== n.page.kind,
  opleidingenOverview: (o, n) => o.page.kind !== n.page.kind,
  magazinesOverviewPage: (o, n) => o.page.kind !== n.page.kind,
  notFound: (o, n) => o.page.kind !== n.page.kind,
  home: (o, n) => o.page.kind !== n.page.kind,
  empty: (o, n) => o.page.kind !== n.page.kind,
  previewPage: (o, n) => o.page.kind !== n.page.kind,
  cmsPage: (o, n) => {
    if (o.page.kind !== 'cmsPage' || n.page.kind !== 'cmsPage') {
      return n.page.kind !== o.page.kind
    }
    return o.page.params.slug !== n.page.params.slug
  }
}
